import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { id: "name" }
const _hoisted_3 = { class: "child" }
const _hoisted_4 = { class: "child" }

import { ref } from 'vue'

import Tournaments from './Tournaments.vue'
import TopOpponents from './TopOpponents.vue'
import Transactions from './Transactions.vue'
import QA from './QA.vue'
import AttributesUpdatePrompt from './AttributesUpdatePrompt.vue'
import useQuasar from 'quasar/src/composables/use-quasar.js';import Loading from 'quasar/src/plugins/Loading.js';
import NewTransaction from './NewTransaction.vue'
import { DiffItem } from './AttributesUpdatePrompt.vue'
import NewTransactionPrompt from './NewTransactionPrompt.vue'
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { GetLogs, GetUser, NewTransaction as CallNewTransaction, UpdateUser, SettleWithdrawal } from './code/api'
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { signin } from './code/firebase-manager'
import Withdrawal from './components/Withdrawal.vue'
import UserProperties from './components/UserProperties.vue'
import { GetUserOutput, Transaction, UserUpdate } from './code/models'
import ConfirmPopup from './components/ConfirmPopup.vue'
import { centsToDollars } from './code/utils'
import * as API from './code/api'
import UserGameStats from './components/UserGameStats.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'User',
  setup(__props) {

const firebaseConfig = {
  apiKey: "AIzaSyCPDpMag043W7C6JgVxpme9NHTKi9586XQ",
  authDomain: "parana-portal-dev.firebaseapp.com",
  projectId: "parana-portal-dev",
  storageBucket: "parana-portal-dev.appspot.com",
  messagingSenderId: "287340631223",
  appId: "1:287340631223:web:2d948375c95b907efee932"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

var token = ''

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());
const id = params.id

console.log('params', params)
auth.onAuthStateChanged(function (user: any) {
  if (!user) {
    alert('you must be logged in to view this page')
    signin()
  } else {
    console.log('user: ', user)
    token = user.accessToken
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    GetUser(params.id, user.accessToken).then((result) => { viewModel.value = result; console.log('out', result) })
  }
})

const viewModel = ref<GetUserOutput>()
const userUpdate = ref<UserUpdate>({ Level: '', XPInLevel: '', Status: '', Suspended: false, UserID: '' })
const $q = useQuasar()
const diff = ref<DiffItem[]>([])

function userPropertyChipClicked(input: { key: string, value: string }) {
  if (input.key.startsWith('Edit')) {
    window.open(input.value);
  }
}

function submitUserUpdate(newUser: UserUpdate) {
  var diffArray: DiffItem[] = []
  for (const attribute of Object.keys(newUser)) {
    const old = (viewModel.value?.User as any)[attribute]
    const newAtt = (newUser as any)[attribute]
    if (newAtt === '' || newAtt === old) continue
    diffArray.push({ Name: attribute, Old: old, New: newAtt })
  }

  diff.value = diffArray
  console.log('diff array', diff.value)

  const dialog = $q.dialog({ component: AttributesUpdatePrompt, componentProps: { diff: diff.value } })
    .onOk(() => {
      console.log('user ok')
      if (!userUpdate.value) return
      userUpdate.value.UserID = id
      UpdateUser(userUpdate.value, token, () => {
        Loading.hide()
        dialog.hide()
      })
    }).onCancel(() => {
    }).onDismiss(() => {
    })
}

async function downloadGameMovesClicked(props: { rowIndex: number }) {
  console.log('GameSessionArn', viewModel.value?.Tournaments[props.rowIndex]?.GameSession?.GameSessionArn)
  var tournamentId = viewModel.value?.Tournaments[props.rowIndex]?.ID
  console.log('TournamentID', tournamentId)
  if (!tournamentId) return;
  await API.downloadGameMoves(tournamentId, id, token, (data: any, error?: Error) => {
    if (error) {
      console.log('error', error)
      return
    }
    console.log(data)
    navigator.clipboard.writeText(data)
  });
}

async function onLogsClick(props: { rowIndex: number }) {
  console.log('GameSessionArn', viewModel.value?.Tournaments[props.rowIndex]?.GameSession?.GameSessionArn)
  var tournamentId = viewModel.value?.Tournaments[props.rowIndex]?.ID
  console.log('TournamentID', tournamentId)
  if (!tournamentId) return;
  var logs = await GetLogs(tournamentId, token);
  window.open(logs, '_blank');
}

function deleteUserClicked() {
  console.log('ajsdhalkshd')
  const dialog = $q.dialog({ component: ConfirmPopup, componentProps: { vm: { Title: 'Are you sure you want to delete this user?' } } })
    .onOk((ok) => {
      Loading.show()
      API.DeleteUser(id, token, () => {
        Loading.hide()
        dialog.hide()
      })
      console.log('delete confirmed')
    }).onCancel(() => {
      console.log('delete cancelled')
      // dialog.hide()
    }).onDismiss(() => {
      console.log('delete dismissed')
    })
  console.log('deleting user')
}

function withdrawalClicked(approved: boolean) {
  console.log('approved', approved)
  const dollars = centsToDollars((viewModel.value?.WithdrawalRequest?.Cash ?? 0) - 100)
  const title = `${approved ? 'Approve' : 'Reject'} ${dollars} withdrawal?`

  const dialog = $q.dialog({ component: ConfirmPopup, componentProps: { vm: { Title: title } } })
    .onOk((ok) => {
      Loading.show()
      SettleWithdrawal(id, approved, token, (success: boolean) => {
        Loading.hide()
        dialog.hide()
        if (success) {
          const msg = approved ? '💰 Money sent! 🤑' : 'Successfully rejected'
          $q.notify({ type: 'positive', message: msg })
        } else {
          const msg = approved ? `😬 Couldn't send money 👎` : 'Reject failed'
          $q.notify({ type: 'negative', message: msg })
        }
      })
    }).onCancel(() => {
    }).onDismiss(() => {
    })
}

function submitTransactionClicked(transaction: Transaction) {
  const transactions = [transaction]
  console.log('you clicked submit transaction', transactions)

  const dialog = $q.dialog({ component: NewTransactionPrompt, componentProps: { transactions: transactions } })
    .onOk((ok) => {
      Loading.show()
      CallNewTransaction(id, transactions[0], token, () => {
        Loading.hide()
        dialog.hide()
      })
    }).onCancel(() => {
    }).onDismiss(() => {
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(viewModel.value?.Contact?.Name), 1),
      _createElementVNode("h1", _hoisted_3, _toDisplayString(viewModel.value?.User?.Email), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(viewModel.value?.Contact?.Phone), 1)
    ]),
    (viewModel.value?.Balance)
      ? (_openBlock(), _createBlock(UserProperties, {
          key: 0,
          properties: viewModel.value?.Balance
        }, null, 8, ["properties"]))
      : _createCommentVNode("", true),
    (viewModel.value?.UserStats)
      ? (_openBlock(), _createBlock(UserProperties, {
          key: 1,
          onChipClicked: userPropertyChipClicked,
          properties: viewModel.value?.UserStats
        }, null, 8, ["properties"]))
      : _createCommentVNode("", true),
    (viewModel.value?.UserGameStats)
      ? (_openBlock(), _createBlock(UserGameStats, {
          key: 2,
          "pvp-data": viewModel.value?.UserGameStats.pvpData,
          "pnc-data": viewModel.value?.UserGameStats.pncData
        }, null, 8, ["pvp-data", "pnc-data"]))
      : _createCommentVNode("", true),
    _createVNode(NewTransaction, {
      onSubmitTransactionClicked: submitTransactionClicked,
      class: "card"
    }),
    (viewModel.value?.WithdrawalRequest)
      ? (_openBlock(), _createBlock(Withdrawal, {
          key: 3,
          request: viewModel.value?.WithdrawalRequest,
          onWithdrawalClicked: withdrawalClicked,
          class: "card"
        }, null, 8, ["request"]))
      : _createCommentVNode("", true),
    _createVNode(AttributesUpdatePrompt),
    _createVNode(NewTransactionPrompt),
    (viewModel.value?.TopOpponents)
      ? (_openBlock(), _createBlock(TopOpponents, {
          key: 4,
          topOpponents: viewModel.value?.TopOpponents
        }, null, 8, ["topOpponents"]))
      : _createCommentVNode("", true),
    (viewModel.value?.Tournaments)
      ? (_openBlock(), _createBlock(Tournaments, {
          key: 5,
          onOnLogsClick: onLogsClick,
          onDownloadGameMovesClicked: downloadGameMovesClicked,
          tournaments: viewModel.value?.Tournaments
        }, null, 8, ["tournaments"]))
      : _createCommentVNode("", true),
    (viewModel.value?.Transactions)
      ? (_openBlock(), _createBlock(Transactions, {
          key: 6,
          transactions: viewModel.value?.Transactions
        }, null, 8, ["transactions"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})